import React, { useState, useEffect } from 'react';
import './midcontent.scss';
import { Link, useLocation } from 'react-router-dom';
import Loader from '../Loader/Loader';

const AllBestReviews = () => {
  const location = useLocation();
  const isRootPath = location.pathname === '/';

  const [reviews, setReviews] = useState([]);
  const [load, setLoad] = useState(true);
  const [err, setErr] = useState(null);

  useEffect(() => {
    const fetchReviews = async () => {
      setLoad(true);
      try {
        const response = await fetch(`https://backend.indianjewelryish.com/api/all-fetch-best-reviews`);
        if (!response.ok) throw new Error('Failed to fetch reviews');
        const data = await response.json();
        setReviews(data?.reviews || []);
      } catch (error) {
        setErr(error.message);
      } finally {
        setLoad(false);
      }
    };

    fetchReviews();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [reviews]);

  if (load) return <Loader />;
  if (err) return <div className="error">{err}</div>;
  // console.log(reviews);
  return (
    <>
      <section id='midcontent'>
        {reviews.map((review) => (
          <div key={review.id} className="card d-flex justify-content-between review-card">
            {/* Show image only if available */}
            {review.review_image_1 ? (
              <div className='image-container'>
                <img src={`https://backend.indianjewelryish.com/${review.review_image_1}`} alt={review.review} />
              </div>
            ) : (
              <div className='image-container'>
                <img src={`https://backend.indianjewelryish.com/${review.product.product_image_1}`} alt={review.review} />
              </div>
            )}
            <h3 className='mb-0'>{review.review}</h3>
            <div className="d-flex justify-content-center p-0 m-0">
              {Array.from({ length: 5 }).map((_, index) => (
                <span style={{ "font-size": "14px" }} key={index}>
                  {index < review.rating ? '★' : ''}
                </span>
              ))}
            </div>
            <Link to={`/productshow/${review.product.product_code}`}>
               <button className="loginsignupbutton w-80" style={{padding:'5px'}}>Show Product</button>
            </Link>
          </div>
        ))}
      </section>

    </>
  );
};

export default AllBestReviews;
